export const getFiltersListFromCustomConfig = ({config}) => config.map(({name}) => name)
